import { describe, it } from "vitest";

describe("decodeGeometryColumn", () => {
    it("should decode mixed LineString, Polygon, MultiLineString and MultiPolygon geometry", async () => {});
});
